(function() {
    // ── Error Logger ──
    function _logError(context, error, extra) {
      console.error('[MIF:' + context + ']', error && error.message ? error.message : String(error), extra || '');
    }

    var root = document.querySelector('[data-loyalty-root]');
    if (!root) return;

    var loadingEl = root.querySelector('[data-loyalty-loading]');
    var loggedInWrapper = root.querySelector('[data-loyalty-logged-in]');
    var loggedOutMsg = root.querySelector('[data-loyalty-logged-out]');

    function showLoggedInUI() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (loggedInWrapper) loggedInWrapper.style.display = 'flex';
      if (loggedOutMsg) loggedOutMsg.style.display = 'none';
    }

    function showLoggedOutUI() {
      if (loadingEl) loadingEl.style.display = 'none';
      if (loggedInWrapper) loggedInWrapper.style.display = 'none';
      if (loggedOutMsg) loggedOutMsg.style.display = 'flex';
    }

    // Detect login by checking if /account redirects to login
    function checkLoginStatus() {
      return fetch('/account', {
        method: 'GET',
        credentials: 'include',
        redirect: 'manual'
      })
      .then(function(response) {
        // If we get a redirect (302) or the response URL contains 'login', user is not logged in
        // If we get 200 and stay on /account, user is logged in
        console.log('Login check response:', response.status, response.type, response.url);

        // 'opaqueredirect' means there was a redirect (to login page)
        if (response.type === 'opaqueredirect') {
          return { isLoggedIn: false, email: null };
        }

        // If status is 200, we're on the account page = logged in
        if (response.ok) {
          // Try to extract email from the page
          return response.text().then(function(html) {
            var emailMatch = html.match(/([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/);
            var email = emailMatch ? emailMatch[1] : null;
            console.log('Extracted email from /account:', email);
            return { isLoggedIn: true, email: email };
          });
        }

        return { isLoggedIn: false, email: null };
      })
      .catch(function(err) {
        _logError('loginCheck', err);
        return { isLoggedIn: false, email: null };
      });
    }

    // ── Rank Rewards Modal ──
    function initRanksModal(data) {
      var modal = root.querySelector('[data-loyalty-ranks-modal]');
      var openBtn = root.querySelector('[data-loyalty-ranks-open]');
      var closeBtns = root.querySelectorAll('[data-loyalty-ranks-close]');
      var listEl = modal ? modal.querySelector('[data-loyalty-ranks-list]') : null;
      if (!modal || !openBtn || !listEl) return;

      // Read labels from data attributes (set via Shopify editor)
      var labels = {
        points: modal.getAttribute('data-label-points') || 'Points Required',
        reputation: modal.getAttribute('data-label-reputation') || 'Reputation Required',
        discount: modal.getAttribute('data-label-discount') || 'Redemption Discount',
        multiplier: modal.getAttribute('data-label-multiplier') || 'Points Multiplier',
        perks: modal.getAttribute('data-label-perks') || 'Perks',
        current: modal.getAttribute('data-label-current') || 'YOUR RANK',
      };

      var currentTierName = (data && data.tier && data.tier.name) ? data.tier.name : '';
      var ranks = (data && data.ranks) ? data.ranks.slice() : [];
      // Sort ranks by points threshold so current rank stays in natural order
      ranks.sort(function(a, b) { return (a.threshold || 0) - (b.threshold || 0); });

      // Build rank cards
      if (ranks.length === 0) {
        listEl.innerHTML = '<p class="mif-loyalty-label">No ranks configured.</p>';
      } else {
        listEl.innerHTML = '';
        ranks.forEach(function(rank) {
          var isCurrent = rank.name === currentTierName;
          var card = document.createElement('div');
          card.className = 'mif-loyalty-rank-card' + (isCurrent ? ' mif-loyalty-rank-card--current' : '');

          var headerHtml = '<div class="mif-loyalty-rank-card__header">'
            + '<h3 class="mif-loyalty-rank-card__name">' + _esc(rank.name) + '</h3>'
            + (isCurrent ? '<span class="mif-loyalty-rank-card__badge">' + _esc(labels.current) + '</span>' : '')
            + '</div>';

          var reqsHtml = '<div class="mif-loyalty-rank-card__reqs">'
            + '<div class="mif-loyalty-rank-card__req">'
            +   '<span class="mif-loyalty-rank-card__req-label">' + _esc(labels.points) + '</span>'
            +   '<span class="mif-loyalty-rank-card__req-value">' + (rank.threshold || 0) + '</span>'
            + '</div>'
            + '<div class="mif-loyalty-rank-card__req">'
            +   '<span class="mif-loyalty-rank-card__req-label">' + _esc(labels.reputation) + '</span>'
            +   '<span class="mif-loyalty-rank-card__req-value">' + (rank.reputation_threshold || 0) + '</span>'
            + '</div>'
            + '</div>';

          var perksHtml = '<div class="mif-loyalty-rank-card__perks-grid">';
          if (rank.discount > 0) {
            perksHtml += '<span class="mif-loyalty-rank-card__perk">' + _esc(labels.discount) + ': <span class="mif-loyalty-rank-card__perk-value">' + rank.discount + '%</span></span>';
          }
          if (rank.points_multiplier > 1) {
            perksHtml += '<span class="mif-loyalty-rank-card__perk">' + _esc(labels.multiplier) + ': <span class="mif-loyalty-rank-card__perk-value">' + rank.points_multiplier + 'x</span></span>';
          }
          if (!rank.discount && rank.points_multiplier <= 1) {
            perksHtml += '<span class="mif-loyalty-rank-card__perk" style="color:#7a8090;">No bonus perks</span>';
          }
          perksHtml += '</div>';

          // Custom perks text (set in admin)
          var customPerks = '';
          if (rank.perks && rank.perks.trim()) {
            customPerks = '<div class="mif-loyalty-rank-card__perks-custom">'
              + '<p class="mif-loyalty-rank-card__perks-heading">' + _esc(labels.perks) + '</p>'
              + '<p class="mif-loyalty-rank-card__perks-text">' + _esc(rank.perks) + '</p>'
              + '</div>';
          }

          card.innerHTML = headerHtml + reqsHtml + perksHtml + customPerks;
          listEl.appendChild(card);
        });
      }

      // Move modal to document.body so no ancestor transform/filter breaks position:fixed centering
      if (modal.parentElement !== document.body) document.body.appendChild(modal);

      // Open / close handlers
      function openModal() {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        // In WebViews position:fixed is broken — modal uses position:absolute,
        // so pin it to the current scroll offset and cover the viewport.
        if (document.documentElement.classList.contains('mif-webview')) {
          modal.style.top = window.scrollY + 'px';
          modal.style.height = window.innerHeight + 'px';
        }
        // Scroll to current rank card so it's visible on open
        var currentCard = listEl.querySelector('.mif-loyalty-rank-card--current');
        if (currentCard) {
          requestAnimationFrame(function() {
            // Scroll the modal body so the current rank is centered
            var bodyTop = listEl.getBoundingClientRect().top;
            var cardTop = currentCard.getBoundingClientRect().top;
            var cardHeight = currentCard.offsetHeight;
            var bodyHeight = listEl.clientHeight;
            listEl.scrollTop = (cardTop - bodyTop) - (bodyHeight / 2) + (cardHeight / 2);
          });
        }
      }
      function closeModal() { modal.style.display = 'none'; document.body.style.overflow = ''; }

      openBtn.addEventListener('click', openModal);
      for (var i = 0; i < closeBtns.length; i++) {
        closeBtns[i].addEventListener('click', closeModal);
      }
      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && modal.style.display !== 'none') closeModal();
      });
    }

    // Simple HTML escape helper
    function _esc(str) {
      var div = document.createElement('div');
      div.appendChild(document.createTextNode(str || ''));
      return div.innerHTML;
    }

    function renderDashboard(data, customerEmail) {
      // Callsign
      var callsignDisplay = root.querySelector('[data-loyalty-callsign-display]');
      var callsignInput = root.querySelector('[data-loyalty-callsign-input]');
      var callsignSaveBtn = root.querySelector('[data-loyalty-callsign-save]');
      var callsignStatus = root.querySelector('[data-loyalty-callsign-status]');

      if (data && data.customer && data.customer.nickname) {
        if (callsignDisplay) callsignDisplay.textContent = data.customer.nickname;
        if (callsignInput) callsignInput.value = data.customer.nickname;
      } else if (customerEmail) {
        // Use email prefix as default display name
        var displayName = customerEmail.split('@')[0];
        if (callsignDisplay) callsignDisplay.textContent = displayName;
      }

      if (callsignSaveBtn && callsignInput && customerEmail) {
        callsignSaveBtn.onclick = function() {
          var newCallsign = callsignInput.value.trim();
          if (!newCallsign) {
            if (callsignStatus) callsignStatus.textContent = 'Please enter a callsign.';
            return;
          }

          callsignSaveBtn.disabled = true;
          callsignSaveBtn.textContent = 'Saving...';
          if (callsignStatus) callsignStatus.textContent = '';

          fetch('/apps/loyalty/dashboard?email=' + encodeURIComponent(customerEmail), {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ nickname: newCallsign })
          })
          .then(function(res) {
            if (!res.ok) throw new Error('HTTP ' + res.status);
            return res.json();
          })
          .then(function(result) {
            callsignSaveBtn.disabled = false;
            callsignSaveBtn.textContent = 'Save';
            if (callsignDisplay) callsignDisplay.textContent = newCallsign;
            if (callsignStatus) {
              callsignStatus.textContent = 'Callsign updated!';
              callsignStatus.className = 'mif-loyalty-callsign-status mif-loyalty-callsign-status--success';
            }

            // Sync callsign to Discord nickname if linked
            fetch('/apps/loyalty/social/discord/sync', {
              method: 'POST',
              credentials: 'include',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ email: customerEmail })
            })
            .then(function(res) { return res.json(); })
            .then(function(syncResult) {
              if (syncResult.ok && syncResult.synced && callsignStatus) {
                callsignStatus.textContent = 'Callsign updated! Discord nickname synced.';
              }
            })
            .catch(function() { /* Discord sync is best-effort */ });
          })
          .catch(function(err) {
            _logError('callsign', err, { action: 'save' });
            callsignSaveBtn.disabled = false;
            callsignSaveBtn.textContent = 'Save';
            if (callsignStatus) {
              callsignStatus.textContent = 'Failed to save. Please try again.';
              callsignStatus.className = 'mif-loyalty-callsign-status mif-loyalty-callsign-status--error';
            }
          });
        };
      }

      if (!data) return;

      // Points
      var availableEl = root.querySelector('[data-loyalty-points-available]');
      var totalEl = root.querySelector('[data-loyalty-points-total]');
      if (availableEl && data.points && typeof data.points.available !== 'undefined') {
        availableEl.textContent = data.points.available.toString();
      }
      if (totalEl && data.points && typeof data.points.total !== 'undefined') {
        totalEl.textContent = 'Total earned: ' + data.points.total.toString();
      }

      // Tier
      var tierNameEl = root.querySelector('[data-loyalty-tier-name]');
      var tierDiscountEl = root.querySelector('[data-loyalty-tier-discount]');
      var tierProgressTextEl = root.querySelector('[data-loyalty-tier-progress-text]');
      var pointsBarFill = root.querySelector('[data-loyalty-points-bar-fill]');
      var pointsBarText = root.querySelector('[data-loyalty-points-bar-text]');
      var repBarFill = root.querySelector('[data-loyalty-rep-bar-fill]');
      var repBarText = root.querySelector('[data-loyalty-rep-bar-text]');

      if (data.tier) {
        if (tierNameEl && data.tier.name) {
          tierNameEl.textContent = data.tier.name;
        }
        if (tierDiscountEl && typeof data.tier.discount_percent !== 'undefined') {
          var discountText = 'Redemption discount: ' + data.tier.discount_percent + '%';
          if (data.tier.points_multiplier && data.tier.points_multiplier > 1) {
            discountText += '  ·  Points bonus: ' + data.tier.points_multiplier + 'x';
          }
          tierDiscountEl.textContent = discountText;
        }

        var isMaxRank = data.tier.next_tier_points === null || typeof data.tier.next_tier_points === 'undefined';

        // Points progress bar
        if (pointsBarFill && pointsBarText) {
          if (isMaxRank) {
            pointsBarFill.style.width = '100%';
            pointsBarText.textContent = data.tier.points_progress + ' pts (max)';
          } else {
            var ptsPct = data.tier.next_tier_points > 0
              ? Math.min(100, Math.floor((data.tier.points_progress / data.tier.next_tier_points) * 100))
              : 100;
            pointsBarFill.style.width = ptsPct + '%';
            pointsBarText.textContent = data.tier.points_progress + ' / ' + data.tier.next_tier_points;
          }
        }

        // Reputation progress bar
        if (repBarFill && repBarText) {
          if (isMaxRank) {
            repBarFill.style.width = '100%';
            repBarText.textContent = data.tier.reputation_progress + ' rep (max)';
          } else {
            var repTarget = data.tier.next_tier_reputation || 0;
            var repPct = repTarget > 0
              ? Math.min(100, Math.floor((data.tier.reputation_progress / repTarget) * 100))
              : 100;
            repBarFill.style.width = repPct + '%';
            repBarText.textContent = data.tier.reputation_progress + ' / ' + (repTarget || '0');
          }
        }

        // Summary text
        if (tierProgressTextEl) {
          if (isMaxRank) {
            tierProgressTextEl.textContent = 'Max rank reached.';
          } else {
            tierProgressTextEl.textContent = 'Next rank: ' + data.tier.next_tier_name + ' — ' + (data.tier.progress_percent || 0) + '% overall';
          }
        }
      }

      // Referral
      var refLinkInput = root.querySelector('[data-loyalty-referral-link]');
      var refCopyButton = root.querySelector('[data-loyalty-referral-copy]');
      var refCountEl = root.querySelector('[data-loyalty-referral-count]');
      var refPendingEl = root.querySelector('[data-loyalty-referral-pending]');
      if (data.referral) {
        if (refLinkInput && data.referral.link) {
          refLinkInput.value = data.referral.link;
        }
        if (refCountEl && typeof data.referral.successful_referrals !== 'undefined') {
          refCountEl.textContent = data.referral.successful_referrals.toString();
        }
        if (refPendingEl && typeof data.referral.pending_referrals !== 'undefined') {
          refPendingEl.textContent = data.referral.pending_referrals.toString();
        }
      }
      if (refCopyButton && refLinkInput) {
        refCopyButton.onclick = function() {
          try {
            refLinkInput.select();
            document.execCommand('copy');
            refCopyButton.textContent = 'Copied!';
            setTimeout(function() { refCopyButton.textContent = 'Copy'; }, 2000);
          } catch (e) {
            console.warn('Copy failed', e);
          }
        };
      }

      // Missions
      var missionsContainer = root.querySelector('[data-loyalty-missions-list]');
      if (missionsContainer && Array.isArray(data.missions)) {
        missionsContainer.innerHTML = '';
        if (data.missions.length === 0) {
          missionsContainer.innerHTML = '<p class="mif-loyalty-label">No active missions available.</p>';
        } else {
          var referralLink = data.referral && data.referral.link ? data.referral.link : '';

          data.missions.forEach(function(mission) {
            var card = document.createElement('article');
            card.className = 'mif-loyalty-mission-card';
            card.setAttribute('data-mission-id', mission.id);

            var isCompleted = mission.status === 'completed';
            var statusLabel = isCompleted ? 'Completed' : 'Available';

            if (isCompleted) {
              card.classList.add('mif-loyalty-mission-card--completed');
            }

            // Build footer based on mission type
            var footerHtml = '';
            if (mission.id === 'refer_a_friend' && !isCompleted) {
              if (referralLink) {
                footerHtml = '<div class="mif-loyalty-mission-card__footer">'
                  + '<div class="mif-loyalty-referral-link-row" style="display:flex;gap:6px;align-items:center;width:100%;">'
                  +   '<input type="text" readonly value="' + referralLink + '" class="mif-loyalty-referral-input" style="flex:1;font-size:0.78rem;padding:6px 8px;border-radius:6px;border:1px solid rgba(255,255,255,0.1);background:#101116;color:#f4f4f4;">'
                  +   '<button type="button" class="mif-loyalty-button mif-loyalty-button--small" data-copy-referral>Copy Referral Link</button>'
                  + '</div>'
                  + '</div>';
              } else {
                footerHtml = '<div class="mif-loyalty-mission-card__footer">'
                  + '<button type="button" class="mif-loyalty-button mif-loyalty-button--small" data-mission-action>'
                  +   'Copy Referral Link'
                  + '</button>'
                  + '</div>';
              }
            } else if (!isCompleted && mission.action_url) {
              footerHtml = '<div class="mif-loyalty-mission-card__footer">'
                + '<a href="' + mission.action_url + '" class="mif-loyalty-button mif-loyalty-button--small" data-mission-action>'
                +   'Begin Mission'
                + '</a>'
                + '</div>';
            }

            card.innerHTML = ''
              + '<div class="mif-loyalty-mission-card__header">'
              +   '<div class="mif-loyalty-mission-meta">'
              +     '<span class="mif-loyalty-chip mif-loyalty-chip--mission">'
              +       (mission.type || 'mission')
              +     '</span>'
              +     '<span class="mif-loyalty-mission-status mif-loyalty-mission-status--' + statusLabel.toLowerCase() + '">'
              +       statusLabel
              +     '</span>'
              +   '</div>'
              +   '<h3 class="mif-loyalty-mission-title">' + (mission.title || '') + '</h3>'
              + '</div>'
              + '<div class="mif-loyalty-mission-card__body">'
              +   '<p class="mif-loyalty-mission-description">' + (mission.description || '') + '</p>'
              +   '<p class="mif-loyalty-mission-reward">' + (isCompleted ? 'Earned: ' : 'Reward: ') + (mission.points_reward || 0) + ' core points' + (mission.reputation_reward ? ' + ' + mission.reputation_reward + ' reputation points' : '') + '</p>'
              +   (mission.cooldown_hours ? '<p class="mif-loyalty-mission-cooldown" style="font-size:0.75rem;color:#a5acb8;margin:4px 0 0;">Cooldown: ' + (mission.cooldown_hours >= 24 ? Math.floor(mission.cooldown_hours / 24) + 'd ' + (mission.cooldown_hours % 24 ? (mission.cooldown_hours % 24) + 'h' : '') : mission.cooldown_hours + 'h') + '</p>' : '')
              + '</div>'
              + footerHtml;

            // Copy referral link handler
            var copyBtn = card.querySelector('[data-copy-referral]');
            if (copyBtn) {
              copyBtn.addEventListener('click', function() {
                var input = card.querySelector('.mif-loyalty-referral-input');
                if (input) {
                  navigator.clipboard.writeText(input.value).then(function() {
                    copyBtn.textContent = 'Copied!';
                    setTimeout(function() { copyBtn.textContent = 'Copy'; }, 2000);
                  });
                }
              });
            }

            missionsContainer.appendChild(card);
          });
        }
      }

      // Activity
      var activityContainer = root.querySelector('[data-loyalty-activity-list]');
      if (activityContainer && Array.isArray(data.activity)) {
        activityContainer.innerHTML = '';
        if (data.activity.length === 0) {
          activityContainer.innerHTML = '<li class="mif-loyalty-label">No recent activity.</li>';
        } else {
          data.activity.forEach(function(entry) {
            var li = document.createElement('li');
            li.className = 'mif-loyalty-activity-item';

            // Build points detail line
            var detailParts = [];
            if (entry.points && entry.points !== 0) {
              var sign = entry.points > 0 ? '+' : '';
              detailParts.push(sign + entry.points + ' core points');
            }
            if (entry.reputation && entry.reputation !== 0) {
              var repSign = entry.reputation > 0 ? '+' : '';
              detailParts.push(repSign + entry.reputation + ' reputation points');
            }
            var detailHtml = detailParts.length > 0
              ? '<p class="mif-loyalty-activity-detail">' + detailParts.join(' &middot; ') + '</p>'
              : '';

            // Format timestamp
            var timestamp = entry.created_at || '';
            if (timestamp) {
              try {
                var d = new Date(timestamp);
                if (!isNaN(d)) timestamp = d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
              } catch(e) {}
            }

            li.innerHTML = ''
              + '<div class="mif-loyalty-activity-item__marker"></div>'
              + '<div class="mif-loyalty-activity-item__content">'
              +   '<p class="mif-loyalty-activity-message">' + _esc(entry.message || '') + '</p>'
              +   detailHtml
              +   '<p class="mif-loyalty-activity-timestamp">' + timestamp + '</p>'
              + '</div>';
            activityContainer.appendChild(li);
          });
        }
      }

      // Rank rewards modal
      initRanksModal(data);

      // File upload handling
      initFileUploads();

      // Submission form handlers - connect to worker API
      var forms = root.querySelectorAll('.mif-loyalty-form');
      forms.forEach(function(form) {
        form.onsubmit = function(e) {
          e.preventDefault();

          // Check for file errors before submitting
          var fileError = form.querySelector('[data-file-error]');
          if (fileError && fileError.style.display !== 'none') {
            return;
          }

          // Check waiver is accepted
          var waiver = form.querySelector('input[name="waiver"]');
          if (waiver && !waiver.checked) {
            showFormError(form, 'Please accept the waiver before submitting.');
            return;
          }

          // Get form type
          var formType = form.getAttribute('data-loyalty-form');
          var submissionType = formType === 'painted-model' ? 'painted-model' : 'battle-report';

          // Get customer email
          if (!currentCustomerEmail) {
            showFormError(form, 'Please log in to submit.');
            return;
          }

          // Gather form data
          var title = '';
          var report = '';
          var titleInput = form.querySelector('input[name="title"]');
          var reportInput = form.querySelector('textarea[name="report"]');
          var notesInput = form.querySelector('textarea[name="notes"]');

          if (titleInput) title = titleInput.value.trim();
          if (reportInput) report = reportInput.value.trim();
          if (notesInput && !report) report = notesInput.value.trim();

          // Validate required fields for battle reports
          if (submissionType === 'battle-report') {
            if (!title) {
              showFormError(form, 'Please enter a title for your battle report.');
              return;
            }
          }

          // Gather all files from the file stores
          var allFiles = [];
          var fileInputs = form.querySelectorAll('.mif-loyalty-file-input');
          fileInputs.forEach(function(input) {
            var files = fileStores.get(input) || [];
            allFiles = allFiles.concat(files);
          });

          // For painted model, at least one image is required
          if (submissionType === 'painted-model' && allFiles.length === 0) {
            showFormError(form, 'Please select at least one image to upload.');
            return;
          }

          // Disable submit button and show loading
          var submitBtn = form.querySelector('button[type="submit"]');
          var originalBtnText = submitBtn ? submitBtn.textContent : 'Submit';
          if (submitBtn) {
            submitBtn.disabled = true;
            submitBtn.textContent = 'Uploading...';
          }

          clearFormError(form);

          // Upload files and submit
          uploadFilesAndSubmit(submissionType, title, report, allFiles, form, submitBtn, originalBtnText);
        };
      });

      function showFormError(form, message) {
        var existingError = form.querySelector('.mif-loyalty-form-error');
        if (existingError) {
          existingError.textContent = message;
          existingError.style.display = 'block';
        } else {
          var errorEl = document.createElement('p');
          errorEl.className = 'mif-loyalty-form-error';
          errorEl.style.cssText = 'color: #ef9a9a; margin: 0.5rem 0; padding: 0.5rem; background: rgba(231,76,60,0.1); border-radius: 4px;';
          errorEl.textContent = message;
          var submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.parentNode.insertBefore(errorEl, submitBtn);
          } else {
            form.appendChild(errorEl);
          }
        }
      }

      function clearFormError(form) {
        var existingError = form.querySelector('.mif-loyalty-form-error');
        if (existingError) {
          existingError.style.display = 'none';
        }
      }

      function showFormSuccess(form, message) {
        var existingSuccess = form.querySelector('.mif-loyalty-form-success');
        if (existingSuccess) {
          existingSuccess.textContent = message;
          existingSuccess.style.display = 'block';
        } else {
          var successEl = document.createElement('p');
          successEl.className = 'mif-loyalty-form-success';
          successEl.style.cssText = 'color: #81c784; margin: 0.5rem 0; padding: 0.5rem; background: rgba(76,175,80,0.1); border-radius: 4px;';
          successEl.textContent = message;
          var submitBtn = form.querySelector('button[type="submit"]');
          if (submitBtn) {
            submitBtn.parentNode.insertBefore(successEl, submitBtn);
          } else {
            form.appendChild(successEl);
          }
        }
      }

      function uploadFilesAndSubmit(type, title, report, files, form, submitBtn, originalBtnText) {
        var uploadedFiles = [];
        var totalFiles = files.length;
        var uploadedCount = 0;

        function updateProgress() {
          if (submitBtn && totalFiles > 0) {
            submitBtn.textContent = 'Uploading ' + (uploadedCount + 1) + '/' + totalFiles + '...';
          }
        }

        function uploadNextFile(index) {
          if (index >= totalFiles) {
            // All files uploaded, now submit the form
            submitSubmission(type, title, report, uploadedFiles, form, submitBtn, originalBtnText);
            return;
          }

          updateProgress();

          var file = files[index];
          var formData = new FormData();
          formData.append('file', file);

          fetch('/apps/loyalty/upload?email=' + encodeURIComponent(currentCustomerEmail), {
            method: 'POST',
            credentials: 'include',
            body: formData
          })
          .then(function(res) {
            return res.json();
          })
          .then(function(data) {
            if (data.ok && data.file) {
              uploadedFiles.push({
                key: data.file.key,
                name: data.file.name,
                type: data.file.type,
                size: data.file.size
              });
              uploadedCount++;
              uploadNextFile(index + 1);
            } else {
              throw new Error(data.error || 'Failed to upload ' + file.name);
            }
          })
          .catch(function(err) {
            _logError('upload', err, { action: 'fileUpload' });
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = originalBtnText;
            }
            showFormError(form, 'Upload failed: ' + err.message);
          });
        }

        if (totalFiles === 0) {
          // No files to upload, submit directly
          submitSubmission(type, title, report, [], form, submitBtn, originalBtnText);
        } else {
          uploadNextFile(0);
        }
      }

      function submitSubmission(type, title, report, files, form, submitBtn, originalBtnText) {
        if (submitBtn) {
          submitBtn.textContent = 'Submitting...';
        }

        var payload = {
          email: currentCustomerEmail,
          type: type,
          title: title || (type === 'painted-model' ? 'Painted Model Submission' : 'Battle Report'),
          report: report || '',
          files: files
        };

        fetch('/apps/loyalty/submissions', {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(res) {
          return res.json();
        })
        .then(function(data) {
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
          }

          if (data.id) {
            // Success - clear form and show success message
            form.reset();

            // Clear file stores, thumbnails, and any upload errors
            var fileInputs = form.querySelectorAll('.mif-loyalty-file-input');
            fileInputs.forEach(function(input) {
              fileStores.set(input, []);
              var field = input.closest('.mif-loyalty-form__field');
              var thumbnails = field.querySelector('[data-file-thumbnails]');
              var status = field.querySelector('[data-file-status]');
              var errorEl = field.querySelector('[data-file-error]');
              if (thumbnails) thumbnails.innerHTML = '';
              if (status) status.textContent = 'No files selected';
              if (errorEl) {
                errorEl.style.display = 'none';
                errorEl.textContent = '';
              }
            });

            showFormSuccess(form, 'Submission received! Your entry will be reviewed and points awarded once approved.');

            // Hide success message after 8 seconds
            setTimeout(function() {
              var successEl = form.querySelector('.mif-loyalty-form-success');
              if (successEl) successEl.style.display = 'none';
            }, 8000);
          } else {
            throw new Error(data.error || 'Submission failed');
          }
        })
        .catch(function(err) {
          _logError('submission', err);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = originalBtnText;
          }
          showFormError(form, 'Submission failed: ' + err.message);
        });
      }

      // Rewards rendering
      renderRewards(data, customerEmail);
    }

    // Store customer email and available points for redemption
    var currentCustomerEmail = null;
    var currentAvailablePoints = 0;

    function renderRewards(dashboardData, customerEmail) {
      currentCustomerEmail = customerEmail;
      currentAvailablePoints = (dashboardData && dashboardData.points) ? dashboardData.points.available : 0;

      var rewardsContainer = root.querySelector('[data-loyalty-rewards-list]');
      if (!rewardsContainer) return;

      // Fetch rewards from the API
      fetch('/apps/loyalty/rewards?email=' + encodeURIComponent(currentCustomerEmail || ''), { credentials: 'include' })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(data) {
          if (!data.ok || !Array.isArray(data.rewards) || data.rewards.length === 0) {
            rewardsContainer.innerHTML = '<p class="mif-loyalty-label">No rewards available at this time.</p>';
            return;
          }

          rewardsContainer.innerHTML = '';

          data.rewards.forEach(function(reward) {
            var card = document.createElement('article');
            card.className = 'mif-loyalty-reward-card';
            card.setAttribute('data-reward-id', reward.id);

            var isRankLocked = reward.rank_locked === true;
            var effectiveCost = reward.discounted_cost || reward.points_cost;
            var canAfford = !isRankLocked && currentAvailablePoints >= effectiveCost;
            var typeLabel = getRewardTypeLabel(reward.type);
            var typeClass = getRewardTypeClass(reward.type);
            var costHtml = reward.discounted_cost
              ? '<span style="text-decoration:line-through;opacity:0.5;margin-right:4px;">' + reward.points_cost + '</span>' + reward.discounted_cost + ' pts'
              : reward.points_cost + ' pts';

            // Rank lock badge
            var rankBadgeHtml = '';
            if (reward.required_rank_name) {
              var badgeStyle = isRankLocked
                ? 'background:rgba(220,53,69,0.15);color:#ff6b6b;border:1px solid rgba(220,53,69,0.3);'
                : 'background:rgba(110,200,122,0.15);color:#6ec87a;border:1px solid rgba(110,200,122,0.3);';
              rankBadgeHtml = '<span style="font-size:0.7rem;padding:2px 8px;border-radius:4px;' + badgeStyle + '">'
                + (isRankLocked ? '🔒 ' : '') + reward.required_rank_name + ' rank'
                + '</span>';
            }

            // Button text
            var buttonText = isRankLocked
              ? 'Requires ' + (reward.required_rank_name || 'Higher Rank')
              : (canAfford ? 'Redeem' : 'Not Enough Points');

            if (isRankLocked) {
              card.style.opacity = '0.6';
            }

            card.innerHTML = ''
              + '<div class="mif-loyalty-reward-card__header">'
              +   '<span class="mif-loyalty-chip mif-loyalty-chip--reward ' + typeClass + '">'
              +     typeLabel
              +   '</span>'
              +   rankBadgeHtml
              +   '<span class="mif-loyalty-reward-cost">'
              +     costHtml
              +   '</span>'
              + '</div>'
              + '<div class="mif-loyalty-reward-card__body">'
              +   '<h3 class="mif-loyalty-reward-name">' + (reward.name || '') + '</h3>'
              +   '<p class="mif-loyalty-reward-description">' + (reward.description || '') + '</p>'
              + '</div>'
              + '<div class="mif-loyalty-reward-card__footer">'
              +   '<button type="button" class="mif-loyalty-button mif-loyalty-button--small' + (canAfford ? '' : ' mif-loyalty-button--disabled') + '" data-redeem-reward="' + reward.id + '"' + (canAfford ? '' : ' disabled') + '>'
              +     buttonText
              +   '</button>'
              + '</div>';

            rewardsContainer.appendChild(card);
          });

          // Attach redeem button handlers
          var redeemButtons = rewardsContainer.querySelectorAll('[data-redeem-reward]');
          redeemButtons.forEach(function(btn) {
            btn.onclick = function() {
              var rewardId = btn.getAttribute('data-redeem-reward');
              redeemReward(rewardId, btn);
            };
          });
        })
        .catch(function(err) {
          _logError('rewards', err, { action: 'fetch' });
          rewardsContainer.innerHTML = '<p class="mif-loyalty-label">Could not load rewards.</p>';
        });
    }

    function getRewardTypeLabel(type) {
      switch (type) {
        case 'discount_percent': return 'Discount';
        case 'gift_card': return 'Gift Card';
        case 'free_shipping': return 'Free Shipping';
        default: return 'Reward';
      }
    }

    function getRewardTypeClass(type) {
      switch (type) {
        case 'discount_percent': return 'mif-loyalty-chip--discount';
        case 'gift_card': return 'mif-loyalty-chip--gift';
        case 'free_shipping': return 'mif-loyalty-chip--shipping';
        default: return '';
      }
    }

    function redeemReward(rewardId, btn) {
      if (!currentCustomerEmail) {
        alert('Please log in to redeem rewards.');
        return;
      }

      btn.disabled = true;
      btn.textContent = 'Redeeming...';

      fetch('/apps/loyalty/redeem', {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: currentCustomerEmail,
          reward_id: rewardId
        })
      })
      .then(function(res) {
        return res.json();
      })
      .then(function(data) {
        if (data.ok) {
          // Update the points display
          currentAvailablePoints = data.redemption.new_balance;
          var availableEl = root.querySelector('[data-loyalty-points-available]');
          if (availableEl) {
            availableEl.textContent = data.redemption.new_balance.toString();
          }

          // Show the success modal with the code
          showRedemptionModal(data.redemption.code);

          // Re-render rewards to update button states
          fetchLoyaltyData(currentCustomerEmail).then(function(newData) {
            renderRewards(newData, currentCustomerEmail);
          });
        } else {
          alert('Redemption failed: ' + (data.error || 'Unknown error'));
          btn.disabled = false;
          btn.textContent = 'Redeem';
        }
      })
      .catch(function(err) {
        _logError('rewards', err, { action: 'redeem' });
        alert('Redemption failed. Please try again.');
        btn.disabled = false;
        btn.textContent = 'Redeem';
      });
    }

    function showRedemptionModal(code) {
      var modal = root.querySelector('[data-loyalty-redemption-modal]');
      var codeEl = root.querySelector('[data-loyalty-redemption-code]');
      var closeBtn = root.querySelector('[data-loyalty-redemption-close]');

      if (!modal || !codeEl) return;

      codeEl.textContent = code;
      modal.style.display = 'flex';

      // Copy code to clipboard on click
      codeEl.onclick = function() {
        try {
          navigator.clipboard.writeText(code).then(function() {
            codeEl.classList.add('mif-loyalty-code-copied');
            setTimeout(function() {
              codeEl.classList.remove('mif-loyalty-code-copied');
            }, 1500);
          });
        } catch (e) {
          // Fallback for older browsers
          var textArea = document.createElement('textarea');
          textArea.value = code;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }
      };

      if (closeBtn) {
        closeBtn.onclick = function() {
          modal.style.display = 'none';
        };
      }

      // Close on backdrop click
      modal.onclick = function(e) {
        if (e.target === modal) {
          modal.style.display = 'none';
        }
      };
    }

    function fetchLoyaltyData(email) {
      var url = '/apps/loyalty/dashboard';
      if (email) {
        url += '?email=' + encodeURIComponent(email);
      }

      return fetch(url, { credentials: 'include' })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        });
    }

    // Render unused rewards
    function renderUnusedRewards(customerEmail) {
      var unusedContainer = root.querySelector('[data-loyalty-unused-rewards-list]');
      if (!unusedContainer) return;

      // Fetch unused rewards from the API
      fetch('/apps/loyalty/unused-rewards?email=' + encodeURIComponent(customerEmail), { credentials: 'include' })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(data) {
          if (!data.ok || !Array.isArray(data.unused_rewards) || data.unused_rewards.length === 0) {
            unusedContainer.innerHTML = '<p class="mif-loyalty-label">No unused rewards at this time.</p>';
            return;
          }

          unusedContainer.innerHTML = '';

          data.unused_rewards.forEach(function(reward) {
            var item = document.createElement('div');
            item.className = 'mif-loyalty-unused-reward-item';

            var redeemedDate = reward.redeemed_at ? new Date(reward.redeemed_at).toLocaleDateString() : '';

            item.innerHTML = ''
              + '<div class="mif-loyalty-unused-reward-header">'
              +   '<h3 class="mif-loyalty-unused-reward-name">' + (reward.name || 'Reward') + '</h3>'
              +   '<span class="mif-loyalty-unused-reward-date">Redeemed ' + redeemedDate + '</span>'
              + '</div>'
              + '<div class="mif-loyalty-unused-reward-code-row">'
              +   '<input type="text" readonly class="mif-loyalty-unused-reward-code-input" value="' + (reward.code || '') + '" data-unused-code="' + (reward.code || '') + '">'
              +   '<button type="button" class="mif-loyalty-unused-reward-copy-btn" data-copy-unused-code>Copy</button>'
              + '</div>';

            unusedContainer.appendChild(item);
          });

          // Attach copy handlers
          var copyButtons = unusedContainer.querySelectorAll('[data-copy-unused-code]');
          copyButtons.forEach(function(btn) {
            btn.onclick = function() {
              var codeInput = btn.parentElement.querySelector('[data-unused-code]');
              if (!codeInput) return;

              var code = codeInput.value;

              // Use modern clipboard API
              if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(code).then(function() {
                  showCopiedFeedback(btn, codeInput);
                }).catch(function() {
                  fallbackCopy(code, btn, codeInput);
                });
              } else {
                fallbackCopy(code, btn, codeInput);
              }
            };
          });
        })
        .catch(function(err) {
          _logError('rewards', err, { action: 'fetchUnused' });
          unusedContainer.innerHTML = '<p class="mif-loyalty-label">Could not load unused rewards.</p>';
        });
    }

    function fallbackCopy(text, btn, codeInput) {
      // Fallback for older browsers - select and copy
      codeInput.select();
      codeInput.setSelectionRange(0, 99999); // For mobile
      try {
        document.execCommand('copy');
        showCopiedFeedback(btn, codeInput);
      } catch (e) {
        console.warn('Fallback copy failed:', e);
      }
    }

    function showCopiedFeedback(btn, codeInput) {
      var originalText = btn.textContent;
      btn.textContent = 'Copied!';
      btn.classList.add('mif-loyalty-unused-reward-copy-btn--copied');

      setTimeout(function() {
        btn.textContent = originalText;
        btn.classList.remove('mif-loyalty-unused-reward-copy-btn--copied');
      }, 2000);
    }

    // File upload handling - matches worker restrictions
    var MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB per file
    var ALLOWED_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    var ALLOWED_DOCUMENT_TYPES = [
      'text/plain',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/rtf',
      'application/vnd.oasis.opendocument.text',
      'application/pdf'
    ];
    var ALLOWED_DOCUMENT_EXTENSIONS = ['.txt', '.doc', '.docx', '.rtf', '.odt', '.pdf'];

    // Store selected files per input (since FileList is immutable)
    var fileStores = new WeakMap();

    function initFileUploads() {
      var fileInputs = root.querySelectorAll('.mif-loyalty-file-input');

      fileInputs.forEach(function(input) {
        var wrapper = input.closest('.mif-loyalty-file-upload');
        var field = input.closest('.mif-loyalty-form__field');
        var btn = wrapper.querySelector('.mif-loyalty-file-btn');
        var status = wrapper.querySelector('[data-file-status]');
        var errorEl = field.querySelector('[data-file-error]');
        var thumbnailsContainer = field.querySelector('[data-file-thumbnails]');
        var maxFiles = parseInt(input.getAttribute('data-max-files')) || 5;
        var fileType = input.getAttribute('data-file-type') || 'image';

        // Initialize file store for this input
        fileStores.set(input, []);

        // Click the styled button to trigger file input
        if (btn) {
          btn.onclick = function(e) {
            e.preventDefault();
            input.click();
          };
        }

        // Validate a single file
        function validateFile(file) {
          var errors = [];

          // Check file size (10MB max)
          if (file.size > MAX_FILE_SIZE) {
            var sizeMB = (file.size / (1024 * 1024)).toFixed(1);
            errors.push('"' + file.name + '" is too large (' + sizeMB + 'MB). Max size is 10MB.');
          }

          // Check file type based on input's data-file-type attribute
          if (fileType === 'image') {
            if (ALLOWED_IMAGE_TYPES.indexOf(file.type) === -1) {
              errors.push('"' + file.name + '" is not a supported image type. Use JPEG, PNG, GIF, or WebP.');
            }
          } else if (fileType === 'document') {
            var ext = '.' + file.name.split('.').pop().toLowerCase();
            var validMime = ALLOWED_DOCUMENT_TYPES.indexOf(file.type) !== -1;
            var validExt = ALLOWED_DOCUMENT_EXTENSIONS.indexOf(ext) !== -1;
            if (!validMime && !validExt) {
              errors.push('"' + file.name + '" is not a supported document type. Use TXT, DOC, DOCX, RTF, ODT, or PDF.');
            }
          }

          return errors;
        }

        // Render thumbnails
        function renderThumbnails() {
          if (!thumbnailsContainer) return;

          var currentFiles = fileStores.get(input) || [];
          thumbnailsContainer.innerHTML = '';

          currentFiles.forEach(function(file, index) {
            var thumb = document.createElement('div');

            if (fileType === 'image') {
              thumb.className = 'mif-loyalty-file-thumbnail';

              // Create image preview
              var img = document.createElement('img');
              img.alt = file.name;

              // Read file and create thumbnail
              var reader = new FileReader();
              reader.onload = function(e) {
                img.src = e.target.result;
              };
              reader.readAsDataURL(file);

              thumb.appendChild(img);
            } else {
              // Document file - show icon and name
              thumb.className = 'mif-loyalty-file-thumbnail mif-loyalty-file-thumbnail--document';

              var icon = document.createElement('span');
              icon.className = 'mif-loyalty-file-thumbnail__icon';
              icon.innerHTML = '&#128196;'; // document emoji

              var name = document.createElement('span');
              name.className = 'mif-loyalty-file-thumbnail__name';
              name.textContent = file.name;

              thumb.appendChild(icon);
              thumb.appendChild(name);
            }

            // Add remove button
            var removeBtn = document.createElement('button');
            removeBtn.type = 'button';
            removeBtn.className = 'mif-loyalty-file-thumbnail__remove';
            removeBtn.innerHTML = '&times;';
            removeBtn.title = 'Remove file';
            removeBtn.setAttribute('data-remove-index', index);

            removeBtn.onclick = function(e) {
              e.preventDefault();
              e.stopPropagation();
              removeFile(index);
            };

            thumb.appendChild(removeBtn);
            thumbnailsContainer.appendChild(thumb);
          });
        }

        // Remove a file by index
        function removeFile(index) {
          var currentFiles = fileStores.get(input) || [];
          currentFiles.splice(index, 1);
          fileStores.set(input, currentFiles);

          // Update UI
          updateStatus();
          renderThumbnails();

          // Clear errors if file count is now valid
          if (errorEl && currentFiles.length <= maxFiles) {
            errorEl.style.display = 'none';
            errorEl.textContent = '';
          }
        }

        // Update status text
        function updateStatus() {
          var currentFiles = fileStores.get(input) || [];

          if (status) {
            if (currentFiles.length === 0) {
              status.textContent = maxFiles === 1 ? 'No file selected' : 'No files selected';
            } else if (currentFiles.length === 1) {
              status.textContent = currentFiles[0].name;
            } else {
              status.textContent = currentFiles.length + ' files selected';
            }
          }
        }

        // Handle file selection
        input.onchange = function() {
          var newFiles = Array.from(input.files);
          var currentFiles = fileStores.get(input) || [];
          var errors = [];

          // Clear previous error
          if (errorEl) {
            errorEl.style.display = 'none';
            errorEl.textContent = '';
          }

          if (newFiles.length === 0) {
            return;
          }

          // Check if adding these files would exceed the limit
          var totalFiles = currentFiles.length + newFiles.length;
          if (totalFiles > maxFiles) {
            errors.push('Maximum ' + maxFiles + ' file' + (maxFiles > 1 ? 's' : '') + ' allowed. You have ' + currentFiles.length + ' and tried to add ' + newFiles.length + '.');
          }

          // Check for duplicates and validate each new file
          var validFiles = [];
          newFiles.forEach(function(file) {
            // Check for duplicate (same name and size)
            var isDuplicate = currentFiles.some(function(existing) {
              return existing.name === file.name && existing.size === file.size;
            });

            if (isDuplicate) {
              errors.push('"' + file.name + '" is already selected.');
              return;
            }

            var fileErrors = validateFile(file);
            if (fileErrors.length > 0) {
              errors = errors.concat(fileErrors);
            } else {
              validFiles.push(file);
            }
          });

          // Display errors if any
          if (errors.length > 0) {
            if (errorEl) {
              errorEl.innerHTML = errors.join('<br>');
              errorEl.style.display = 'block';
            }
          }

          // Add valid files (up to the limit)
          var spaceLeft = maxFiles - currentFiles.length;
          var filesToAdd = validFiles.slice(0, spaceLeft);

          if (filesToAdd.length > 0) {
            currentFiles = currentFiles.concat(filesToAdd);
            fileStores.set(input, currentFiles);
          }

          // Update UI
          updateStatus();
          renderThumbnails();

          // Clear the input so the same file can be selected again if removed
          input.value = '';
        };
      });
    }

    // Accordion toggle
    function initAccordion() {
      var trigger = root.querySelector('[data-loyalty-accordion-trigger]');
      var body = root.querySelector('[data-loyalty-accordion-body]');
      var icon = root.querySelector('[data-loyalty-accordion-icon]');
      var accordion = root.querySelector('[data-loyalty-rewards-accordion]');

      if (!trigger || !body) return;

      // Start collapsed
      body.style.maxHeight = '0px';

      trigger.onclick = function() {
        var isOpen = accordion.classList.contains('mif-loyalty-accordion--open');

        if (isOpen) {
          // Collapse
          body.style.maxHeight = '0px';
          accordion.classList.remove('mif-loyalty-accordion--open');
          if (icon) icon.innerHTML = '&#9660;'; // down arrow
        } else {
          // Expand
          body.style.maxHeight = body.scrollHeight + 'px';
          accordion.classList.add('mif-loyalty-accordion--open');
          if (icon) icon.innerHTML = '&#9650;'; // up arrow
        }
      };

      // Set initial state as collapsed
      if (icon) icon.innerHTML = '&#9660;';
    }

    // Unused rewards accordion toggle
    function initUnusedRewardsAccordion() {
      var trigger = root.querySelector('[data-loyalty-unused-accordion-trigger]');
      var body = root.querySelector('[data-loyalty-unused-accordion-body]');
      var icon = root.querySelector('[data-loyalty-unused-accordion-icon]');
      var accordion = root.querySelector('[data-loyalty-unused-rewards-accordion]');

      if (!trigger || !body) return;

      // Start collapsed
      body.style.maxHeight = '0px';

      trigger.onclick = function() {
        var isOpen = accordion.classList.contains('mif-loyalty-accordion--open');

        if (isOpen) {
          // Collapse
          body.style.maxHeight = '0px';
          accordion.classList.remove('mif-loyalty-accordion--open');
          if (icon) icon.innerHTML = '&#9660;'; // down arrow
        } else {
          // Expand
          body.style.maxHeight = body.scrollHeight + 'px';
          accordion.classList.add('mif-loyalty-accordion--open');
          if (icon) icon.innerHTML = '&#9650;'; // up arrow
        }
      };

      // Set initial state as collapsed
      if (icon) icon.innerHTML = '&#9660;';
    }

    // Discord account linking
    function initDiscordPanel(customerEmail) {
      var panel = root.querySelector('[data-discord-panel]');
      if (!panel) return;

      var linkedEl = panel.querySelector('[data-discord-linked]');
      var unlinkedEl = panel.querySelector('[data-discord-unlinked]');
      var usernameEl = panel.querySelector('[data-discord-username]');
      var linkBtn = panel.querySelector('[data-discord-link]');
      var unlinkBtn = panel.querySelector('[data-discord-unlink]');
      var statusEl = panel.querySelector('[data-discord-status]');

      function showStatus(msg, isError) {
        if (!statusEl) return;
        statusEl.textContent = msg;
        statusEl.style.display = 'block';
        statusEl.style.color = isError ? 'var(--mif-color-error, #ff4444)' : '';
        if (!isError) {
          setTimeout(function() { statusEl.style.display = 'none'; }, 3000);
        }
      }

      function showLinked(username) {
        if (usernameEl) usernameEl.textContent = username;
        if (linkedEl) linkedEl.style.display = 'block';
        if (unlinkedEl) unlinkedEl.style.display = 'none';
      }

      function showUnlinked() {
        if (linkedEl) linkedEl.style.display = 'none';
        if (unlinkedEl) unlinkedEl.style.display = 'block';
      }

      // Fetch current linked status
      fetch('/apps/loyalty/social/accounts?email=' + encodeURIComponent(customerEmail), {
        credentials: 'include'
      })
        .then(function(res) { return res.json(); })
        .then(function(data) {
          if (data.ok && data.accounts && data.accounts.discord) {
            showLinked(data.accounts.discord.username || 'Connected');
          } else {
            showUnlinked();
          }
        })
        .catch(function() { showUnlinked(); });

      // Check for OAuth redirect result
      var params = new URLSearchParams(window.location.search);
      if (params.get('social_linked') === 'discord') {
        showStatus('Discord account linked! Your callsign and Linked role have been synced.');
        // Clean URL
        var cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState(null, '', cleanUrl);
      } else if (params.get('social_error')) {
        showStatus('Discord linking failed: ' + params.get('social_error'), true);
        var cleanUrl = window.location.pathname + window.location.hash;
        window.history.replaceState(null, '', cleanUrl);
      }

      // Link button
      if (linkBtn) {
        linkBtn.onclick = function() {
          linkBtn.disabled = true;
          linkBtn.textContent = 'Connecting...';

          fetch('/apps/loyalty/social/connect/discord?email=' + encodeURIComponent(customerEmail), {
            credentials: 'include'
          })
            .then(function(res) { return res.json(); })
            .then(function(data) {
              if (data.ok && data.authUrl) {
                window.location.href = data.authUrl;
              } else {
                showStatus(data.error || 'Could not start Discord linking.', true);
                linkBtn.disabled = false;
                linkBtn.textContent = 'Link Discord Account';
              }
            })
            .catch(function(err) {
              showStatus('Connection error. Please try again.', true);
              linkBtn.disabled = false;
              linkBtn.textContent = 'Link Discord Account';
            });
        };
      }

      // Unlink button
      if (unlinkBtn) {
        unlinkBtn.onclick = function() {
          unlinkBtn.disabled = true;
          unlinkBtn.textContent = 'Unlinking...';

          fetch('/apps/loyalty/social/unlink', {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: customerEmail, platform: 'discord' })
          })
            .then(function(res) { return res.json(); })
            .then(function(data) {
              if (data.ok) {
                showUnlinked();
                showStatus('Discord account unlinked. Linked role removed.');
              } else {
                showStatus(data.error || 'Failed to unlink.', true);
              }
              unlinkBtn.disabled = false;
              unlinkBtn.textContent = 'Unlink';
            })
            .catch(function() {
              showStatus('Connection error. Please try again.', true);
              unlinkBtn.disabled = false;
              unlinkBtn.textContent = 'Unlink';
            });
        };
      }
    }

    // Main flow
    console.log('Loyalty dashboard: checking login status...');

    checkLoginStatus().then(function(loginResult) {
      console.log('Login check result:', loginResult);

      if (loginResult.isLoggedIn) {
        showLoggedInUI();

        // Fetch loyalty data with the customer's email
        fetchLoyaltyData(loginResult.email)
          .then(function(data) {
            console.log('Loyalty data:', data);
            renderDashboard(data, loginResult.email);
            initAccordion();
            initUnusedRewardsAccordion();
            renderUnusedRewards(loginResult.email);
            initDiscordPanel(loginResult.email);
          })
          .catch(function(err) {
            _logError('loyalty', err, { action: 'fetchDashboard' });
            renderDashboard(null, loginResult.email);
            initAccordion();
            initUnusedRewardsAccordion();
            renderUnusedRewards(loginResult.email);
            initDiscordPanel(loginResult.email);
          });
      } else {
        showLoggedOutUI();
        initAccordion();
        initUnusedRewardsAccordion();
      }
    });
  })();
